import {
  HUMANITARIAN_CASES_LIST_LOADING,
  HUMANITARIAN_CASES_LIST_SUCCESS,
  HUMANITARIAN_CASES_LIST_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { humanitarainCasesUrl } from "api/apiUrls";

export const humanitarainCasesActions = () => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: HUMANITARIAN_CASES_LIST_LOADING, payload: true });
    const response = await listItemsService(`${humanitarainCasesUrl}`);

    dispatch({ type: HUMANITARIAN_CASES_LIST_SUCCESS, payload: response.data });
  } catch (err) {
    dispatch({ type: HUMANITARIAN_CASES_LIST_FAILURE, payload: err });
  } finally {
    dispatch({ type: HUMANITARIAN_CASES_LIST_LOADING, payload: false });
  }
};
